import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckForTokenGuard implements CanActivate {
  private router: Router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    if (route.queryParams.jwt) return true;

    this.router.navigate(['/']);
    return false;
  }
}
